export const odeTecnologyLevels = [
  { value: "TRADITIONAL", label: "Tradicional (actividad del dominio público\
     y de fácil adopción)" },
  { value: "INTERMEDIATE", label: "Intermedia (necesita recursos humanos\
     especializados o utiliza maquinaria y equipo)" },
  { value: "HIGH", label: "Alta (altamente especializada, involucra procesos\
     innovadores, se basa en conocimiento y es intensiva en investigación)" }
];
